import { useAtom } from 'jotai';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { p2lTrophyIconSvg } from '../assets/images';
import { userAtom } from '../jotai-atoms/user.atom';
import { Button } from './Button';

export interface NotificationPlay2LearnInvitationProps {
  show: boolean;
}

export const NotificationPlay2LearnInvitation: React.FC<NotificationPlay2LearnInvitationProps> = ({
  show,
}) => {
  const [user] = useAtom(userAtom);

  const __ = useTranslation().t;
  const buttonLabel = __('watchVideo');
  const buttonHref = user?.context?.p2lEmbeddedZoomPlayerEnabled
    ? `/v4/help/play2learn-onboarding`
    : `/help/gameclass`;

  if (!show) {
    return null;
  }
  return (
    <Container>
      <StyledImg src={p2lTrophyIconSvg} alt="Gameclass Trophy" />
      <div>
        <div>
          <Trans
            alt={__('congratulationsWatchVideoUnlockPlay2Learn')}
            i18nKey="congratulationsWatchVideoUnlockPlay2Learn"
          >
            <strong>Congratulations!</strong> We invite you to watch a 2min video to unlock the{' '}
            <strong>Play2Learn</strong> modality.
          </Trans>
        </div>
        <StyledButton label={buttonLabel} href={buttonHref} size="sm" />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 20px 24px;

  position: fixed;
  z-index: 2;
  width: 431px;
  right: 32px;
  bottom: 48px;

  background: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;

  font-size: 16px;
  line-height: 20px;

  @media screen and (max-width: ${({ theme }) => theme.screenSizes.sm}) {
    width: calc(100% - 32px);
    top: calc(69px + 16px);
    left: 16px;
    right: 16px;
    bottom: auto;
  }
`;

const StyledImg = styled.img`
  margin-right: 12px;
  height: 48px;
`;

const StyledButton = styled(Button)`
  margin-top: 12px;
`;
